import { useEffect, useState } from "react";

/**
 * Returns `true` only once `ready` is true AND at least `minMs` have elapsed
 * since mount. Guarantees a splash/loading screen always plays its full
 * designed sequence instead of getting cut short on fast connections.
 */
export const useMinLoadingTime = (ready: boolean, minMs: number): boolean => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setElapsed(true), minMs);
    return () => clearTimeout(timer);
  }, [minMs]);

  return ready && elapsed;
};
